import { Controller } from "@hotwired/stimulus"

// Hide the element when its [data-action="dismissable#dismiss"] child is clicked.
// Persists the dismissal in localStorage if [data-dismissable-key-value] is set,
// so the banner doesn't re-appear on every page load.
export default class extends Controller {
  static values = { key: String }
  declare keyValue: string

  connect() {
    if (this.keyValue && localStorage.getItem(this.storageKey) === "1") {
      ;(this.element as HTMLElement).remove()
    }
  }

  dismiss() {
    if (this.keyValue) {
      localStorage.setItem(this.storageKey, "1")
    }
    ;(this.element as HTMLElement).remove()
  }

  private get storageKey() {
    return `wtc:dismissed:${this.keyValue}`
  }
}
